import {ParamsEditor as ParamsEditorComponent} from './ParamsEditor.component'
import { connector } from './ParamsEditor.connector';
export const ParamsEditor = connector(ParamsEditorComponent)
